import React, { Component } from "react";
import Storage from "../services/storage.service";

export default class ModalLayout extends Component {
  
  close = () => {
    if (this.props.close) {
      this.props.close();
    }
    if (this.props.corner_close) {
      this.props.corner_close();
    }
  };

  componentDidMount(){
    if( this.props.type !== "no-scroll")
      Storage.set("modal_open", (this.props.type ? this.props.type : "basic"));
  }

  componentWillUnmount(){
    Storage.clear("modal_open");
  }

  render() {
    let title = "";
    if (this.props.title){
      title = <h2 className="vmo-modal-title ">{this.props.title}</h2>;
    }
    if (this.props.title && this.props.extraTitleClass) {
      title = <h2 
        className={"vmo-modal-title " + (this.props.extraTitleClass
          ? 'vmo-modal-title-secondary-style' : '')
        }>{this.props.title}</h2>;
    }

    let size = this.props.size ? this.props.size : "";
    let type = this.props.type ? this.props.type : "basic";

    let closer = this.props.close ? (
      <div className="vmo-modal-close" onClick={this.close}></div>
    ) : (
      ""
    );

    let image = "";
    if(this.props.image){
      image = <div className="vmo-modal-image"><img src={this.props.image} alt="" /></div>
    }

    let content = "";

    if (size === "small") {
      content = (
        <>
          <div className="vmo-modal-inner">
          {closer}
            <div className={`vmo-modal-message vmo-with-icon ${typeof this.props.icon === "string" ? this.props.icon : ''}`}>
              {this.props.children}
            </div>
          </div>
        </>
      );
    } else if (size === "small-no-icon") {
      content = (
        <>
          <div className="vmo-modal-inner">
          {closer}
            <div className="vmo-modal-message">
              {this.props.children}
            </div>
          </div>
        </>
      );
    } else {
      content = (
        <>
          <div className="vmo-modal-inner">

            {this.props.corner_close &&
            <div onClick={()=>this.props.corner_close()}
            className="vmo-modal-corner-close-button"></div>}

            <div className="vmo-modal-header">
              {closer}
              {image}
              {title}
            </div>
            <div className="vmo-modal-content">
              {this.props.border_style}
              <div className="vmo-modal-scroll">
                <div className="vmo-modal-scroll-inner">
                  {this.props.children}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }

    let size_classes = "";
    if(size){
      let sizes = size.split(" ");
      size_classes = [];
      for(let size of sizes){
        size_classes.push(" vmo-modal-" + size);
      }
      size_classes = size_classes.join("");  
    }

    let extras = this.props.extras || "";

    return (
      <div className={"vmo-modal " + extras + size_classes + " vmo-modal-" + type}>
        <div className="vmo-modal-backdrop" onClick={this.close}></div>
        <div className="vmo-modal-centered">{content}</div>
      </div>
    );
  }
}
